module.exports = __webpack_public_path__ + "media/images/vp/icon.user.black-3d92cecb72a92dbff19d46ef86de9832.svg";